<template>
  <!-- Row -->
	<li :class="[ isSelected === true ? 'is-active' : '']"><a @click="selected">{{title}}</a></li>
  <!-- Row -->
</template>

<script>
export default {
  name: "NavTab",
  components: {
	},
	props: {
		isSelected: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			required: true
		}
	},
  data() {
    return {
		};
  },
  created() {
  },
  computed: {
  },
  methods: {
		selected() {
			this.$emit("click")
		}
  },
  watch: {
  }
};
</script>

<style lang="scss">
li {
	a {
		text-transform: none !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/NavTab.vue